import React from 'react'

import { CloseOutlined, MoreTimeOutlined } from '@mui/icons-material'
import { Box, IconButton, Modal, Stack, Typography } from '@mui/material'

import { ChargingPoint } from '@/types/ChargingPoint'

import { IdleTariffSchedule } from '@/modules/Station/IdleTariffSchedule'

import { numericUtils } from '@/utils/numeric'
import { timeUtils } from '@/utils/time'

interface IdleScheduleModalProps {
  open: boolean
  onClose: () => void
  chargingPoint: ChargingPoint
}

export const IdleScheduleModal: React.FC<IdleScheduleModalProps> = ({ open, onClose, chargingPoint }) => {
  const idleRate = chargingPoint.current_idle_rate ?? chargingPoint.idle_rate
  const gracePeriod = timeUtils.formatMinutesToTime(chargingPoint.idle_grace_period_minutes)

  return (
    <Modal open={open} onClose={onClose} aria-describedby="idle-schedule-description">
      <Stack
        direction="column"
        width={360}
        maxWidth="92vw"
        bgcolor="background.paper"
        borderRadius={4}
        padding={3}
        spacing={2}
        tabIndex={-1}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          maxHeight: '85vh',
          overflow: 'hidden',
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" fontWeight="bold">
            Ociosidade por horário
          </Typography>
          <IconButton onClick={onClose} edge="end" size="small" aria-label="Fechar">
            <CloseOutlined />
          </IconButton>
        </Stack>

        <Box sx={{ backgroundColor: 'action.hover', borderRadius: 2, paddingX: 2, paddingY: 1.5 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <MoreTimeOutlined color="primary" sx={{ fontSize: 28 }} />
            <Stack minWidth={0}>
              <Typography variant="caption" color="text.secondary" lineHeight={1.3}>
                Agora:
              </Typography>
              <Typography variant="subtitle1" fontWeight="bold" color="primary" lineHeight={1.35}>
                {numericUtils.formatNumberToBRLCurrency(idleRate)}/min
              </Typography>
            </Stack>
          </Stack>
        </Box>

        <Box sx={{ minHeight: 0, overflowY: 'auto', overscrollBehavior: 'contain' }}>
          <IdleTariffSchedule chargingPoint={chargingPoint} />
        </Box>

        <Typography id="idle-schedule-description" variant="caption" color="text.secondary">
          {gracePeriod
            ? `Depois que a carga termina, você tem ${gracePeriod} para retirar o veículo.`
            : 'Depois que a carga termina, a cobrança começa assim que a tolerância acaba.'}{' '}
          A partir daí a cobrança por minuto segue os horários acima enquanto o veículo continuar conectado, e a
          tolerância não reinicia na virada de horário.
        </Typography>
      </Stack>
    </Modal>
  )
}
